<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <!-- <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryCaseName"
          style="margin-bottom:-20px !important;"
          class="v-offset-none"
          color="purple"
          icon="mdi-folder-open"
          title="案名"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryDate"
          style="margin-bottom:-20px !important;"
          color="indigo"
          icon="mdi-calendar"
          title="資料日期"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryEMS"
          style="margin-bottom:-20px !important;"
          color="light-blue"
          icon="mdi-factory"
          title="EMS"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="(responseAreaData.failRate * 100).toFixed(1) + '%'"
          :class="responseAreaData.warningColor || 'green'"
          :color="responseAreaData.color"
          :icon="responseAreaData.icon || 'mdi-check'"
          class="title-color"
          style="margin-bottom:-20px !important;"
          title="Fail Rate"/>
      </v-flex> -->
      <v-flex
        class="v-flex__first"
        style="margin-top: 55px !important;"
        xs12>
        <material-card
          class="v-flex v-c3-chart"
        >
          <div
            class="chart-btn c3-chart c3-click"
            style="margin-top: -3.5rem!important;">
            <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              箱型圖 [Mode： Color Volume]{{selectedDataType}} {{nits}}nits
              <div class="float-right">
                <!-- <v-autocomplete
                    v-model="selectedDataType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="[
                      { text: 'Luminanece', value: 'luminanece' },
                      { text: 'dlTP', value: 'dlTP' },
                      { text: 'dTP', value: 'dTP' },
                    ]"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  /> -->
              </div>
              <p class="m-0">Factory：{{ propData.factoryName }} ｜ Project：{{ propData.projectName }} ｜ prodId：{{ propData.prodId }}｜ Time Interval：{{ propData.startTime }} ~ {{ propData.endTime }}</p>
              <!-- <h6 class="my-1 float-right">篩選條件最後更新時間：{{ lcdFilterUpdateTime }}</h6> -->
            </material-notification>
            <!-- 使用 div 元素作为容器 -->
            <div id="myChart" style="width: 100%; height: 500px;"></div>
            <!-- <vue-c3 :handler="handler_bar"/> -->
          </div>
          <div >
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;min-width: 200px!important;">
              <v-text-field
                v-model="outlierRangeCoefficient"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                label="outlierRange系数"
                class="v-text-field__slot v-text-field__details-none"
                type="number"
                step="0.01"
                persistent-hint
                outlined
                @keydown.enter="outlierRangeCoefficientChanged"
              />
            </v-flex>
            <v-btn

                    class="mx-0 font-weight-light"
                    color="general"
                    @click="outlierRangeCoefficientChanged()"
                      style="position: absolute;right: 16px;bottom: 16px;"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
          </div>
        </material-card>
         <div v-if="showtable === true">
              <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              <p class="m-0">{{clicktitle}}</p>
              <!-- <h6 class="my-1 float-right">篩選條件最後更新時間：{{ lcdFilterUpdateTime }}</h6> -->
            </material-notification>
 <material-card
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          class="d-table-t0 no-data-left">

        <v-data-table
          :headers="[
            { text: 'BiosSN', value: 'isn' ,class: 'table-width-150',sortable: true},
            { text: 'I1 SN ', value: 'i1sn' ,class: 'table-width-150',sortable: true},
            { text: '值', value: 'value',class: 'table-width-185',sortable: true }
          ]"
          :items="responseData"
          :pagination.sync="pagination.current"
          :rows-per-page-items="rowsAmount"
          :class="{ 'showList': true}"
          class="freeze-title height-row-3"
                      multi-sort
            hide-actions
        >
         <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr>
                <td class="table-width-150">{{ item.isn }}</td>
                <td class="table-width-150">{{ item.i1sn }}</td>
                <td class="table-width-185">{{ item.value }}</td>
                <td class="table-width-300">
                  <v-btn
                    class="mx-0 mr-3 font-weight-bold small"
                    color="orange"
                    @click="downloadHitTraceLog(item.pk)">
                    <v-icon class="mr-2">mdi-download</v-icon>HITTrace LOG
                  </v-btn>
                  <v-btn
                    class="mx-0 font-weight-bold small"
                    color="orange"
                    @click="downloadNBreport(item.pk)">
                    <v-icon class="mr-2">mdi-download</v-icon>NB Report
                  </v-btn>
                </td>
              </tr>
            </template>
        </v-data-table>
        <div
            v-if="pagination.current.rowsPerPage != -1"
            class="text-xs-center pt-2 d-inline-block"
            style="margin-left: 0px;width: calc(100% - 140px);">
            <v-pagination
              v-model="pagination.page"
              :length="pages"/>
          </div>
          <v-autocomplete
            v-if="pagination.current.rowsPerPage != -1"
            v-model="pagination.page"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="pageslist"
            class="v-text-field__slot d-inline-block float-right mr-0"
            style="width: 90px;"
            persistent-hint
            outlined
          />
      </material-card>
      </div>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue'
// import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
// eslint-disable-next-line no-unused-vars
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'
import Plotly from 'plotly.js-dist-min'

export default {
  name: 'ShowLcdCalibration2DXYScatterPlot',
  components: {
    // VueC3
  },
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      propData: {},
      // lcdFilterUpdateTime: '',
      calibrationMode: 'NoGM',
      calibrationModeMenu: [],
      outlierRangeCoefficient: 0.15,
      selectedDataType: '',
      nits: '',
      showtable: false,
      clicktitle: '',
      responseAreaData: [],
      responseData: [],
      newData: [],
      barXaxisItem: ['beforeWx', 'beforeWy', 'finalWx', 'finalWy'],
      barXaxisItemName: ['beforeCalibration_X', 'beforeCalibration', 'afterCalibration_x', 'afterCalibration'],
      barXaxisName: [],
      barXaxisValue: [],
      pagination: {
        page: 1,
        current: {
          descending: null,
          page: 1,
          rowsPerPage: 50,
          sortBy: null,
          totalItems: 0
        }
      },
      pages: 4,
      rowsAmount: [10, 25, 50, 100],
      IsSubmitPage: false
      // handler_bar: new Vue(),
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    pageslist () {
      let i = 0
      const list = []
      if (this.pagination.current.rowsPerPage) {
        for (i = 0; i < Math.ceil(this.pagination.current.totalItems / this.pagination.current.rowsPerPage); i++) {
          list.push(i + 1)
        }
      }
      return list
    },
    options_bar () {
      console.info('this.responseAreaData', this.responseAreaData)
      const xValues = this.responseAreaData.map(item => item.point)

      // 准备两组箱型图数据
      const boxData1 = this.responseAreaData.map(item => ({
        point: item.point,
        min: item.nativeColorVolume.min,
        q1: item.nativeColorVolume.q1,
        median: item.nativeColorVolume.median,
        q3: item.nativeColorVolume.q3,
        max: item.nativeColorVolume.max
      }))

      const boxData2 = this.responseAreaData.map(item => ({
        point: item.point,
        min: item.colorVolume.min,
        q1: item.colorVolume.q1,
        median: item.colorVolume.median,
        q3: item.colorVolume.q3,
        max: item.colorVolume.max
      }))

      // 异常点数据
      const scatterPoints1 = this.responseAreaData.flatMap((item, index) =>
        item.nativeColorVolume.belowBoundaryList.map(d => ({ x: xValues[index], y: d.value }))
          .concat(item.nativeColorVolume.exceedBoundaryList.map(d => ({ x: xValues[index], y: d.value })))
      )

      const scatterPoints2 = this.responseAreaData.flatMap((item, index) =>
        item.colorVolume.belowBoundaryList.map(d => ({ x: xValues[index], y: d.value }))
          .concat(item.colorVolume.exceedBoundaryList.map(d => ({ x: xValues[index], y: d.value })))
      )
      console.info('scatterPoints1', scatterPoints1)
      // 创建箱型图数据 - 直接使用传入的统计值
      function createBoxPlotData (boxData, name, color, xOffset = 0) {
        const x = boxData.map(d => d.point + xOffset)

        return {
          type: 'box',
          name,
          x,
          boxpoints: false,
          marker: { color },
          hoverinfo: 'skip',
          // 手动指定统计值，防止Plotly自动计算
          lowerfence: boxData.map(d => d.min),
          q1: boxData.map(d => d.q1),
          median: boxData.map(d => d.median),
          q3: boxData.map(d => d.q3),
          upperfence: boxData.map(d => d.max)
        }
      }

      // 创建中位线悬停提示
      function createMedianHoverScatter (boxData, name, xOffset, color) {
        return {
          type: 'scatter',
          mode: 'markers',
          x: boxData.map(d => d.point + xOffset),
          y: boxData.map(d => d.median),
          name,
          text: boxData.map(d =>
            `<b>Mode</b>: ${name}<br><b>Point</b>: ${d.point}<br><b>Max</b>: ${d.max}<br><b>Min</b>: ${d.min}<br><b>Q1</b>: ${d.q1}<br><b>Q3</b>: ${d.q3}<br><b>中位數</b>: ${d.median}`
          ),
          hovertemplate: '%{text}<extra></extra>',
          marker: {
            size: 8,
            color,
            opacity: 0 // 完全隐藏，但hover还有效
          },
          showlegend: false,
          hoverlabel: { bgcolor: color, font: { color: 'white' } }
        }
      }

      // 创建异常点散点图

      // 创建两组箱型图数据
      const boxPlotData1 = createBoxPlotData(boxData1, 'Native Colorvolume', '#305BAB', -0.25)
      const boxPlotData2 = createBoxPlotData(boxData2, 'Colorvolume', '#137428', 0.25)

      // 创建两组中位线悬停提示
      const medianHover1 = createMedianHoverScatter(boxData1, 'Native Colorvolume', -0.25, '#305BAB')
      const medianHover2 = createMedianHoverScatter(boxData2, 'Colorvolume', 0.25, '#137428')

      // 创建两组异常点散点图
      const scatterData1 = {
        type: 'scatter',
        mode: 'markers',
        x: scatterPoints1.map(d => d.x - 0.25),
        y: scatterPoints1.map(d => d.y),
        name: 'Abnormal Native Colorvolume',
        marker: { color: '#305BAB', size: 8 },
        hoverinfo: 'skip',
        text: scatterPoints1.map(d => {
        // 根据 point 查找对应的 responseAreaData
          const matchedData = this.responseAreaData.find(item => item.point === d.x)
          if (!matchedData) return `Mode: Abnormal<br>Point: ${d.x.toFixed(2)}<br>数据未找到`

          // 根据 datasetName 选择数据集
          let selectedData = matchedData.nativeColorVolume

          // 确保 selectedData 存在
          if (!selectedData) return `Mode: Abnormal<br>Point: ${d.x.toFixed(2)}<br>数据未找到`

          return (
            `<b>Mode</b>: Original` +
      `<br><b>Point</b>: ${d.x}` +
      `<br><b>Max</b>: ${selectedData.max}` +
      `<br><b>Min</b>: ${selectedData.min}` +
      `<br><b>Q1</b>: ${selectedData.q1}` +
      `<br><b>Q3</b>: ${selectedData.q3}` +
      `<br><b>中位数</b>: ${selectedData.median}` +
      `<br><b>Value</b>: ${d.y}`
          )
        }),
        hovertemplate: '%{text}<extra></extra>' // 直接使用 text 作为 hover 显示内容
      }

      const scatterData2 = {
        type: 'scatter',
        mode: 'markers',
        x: scatterPoints2.map(d => d.x + 0.25),
        y: scatterPoints2.map(d => d.y),
        name: 'Abnormal Colorvolume',
        marker: { color: '#137428', size: 8 },
        hoverinfo: 'skip',
        text: scatterPoints2.map(d => {
        // 根据 point 查找对应的 responseAreaData
          const matchedData = this.responseAreaData.find(item => item.point === d.x)
          if (!matchedData) return `Mode: Abnormal<br>Point: ${d.x.toFixed(2)}<br>数据未找到`

          // 根据 datasetName 选择数据集
          let selectedData = matchedData.colorVolume

          // 确保 selectedData 存在
          if (!selectedData) return `Mode: Abnormal<br>Point: ${d.x.toFixed(2)}<br>数据未找到`

          return (
            `<b>Mode</b>: Calibration` +
      `<br><b>Point</b>: ${d.x}` +
      `<br><b>Max</b>: ${selectedData.max}` +
      `<br><b>Min</b>: ${selectedData.min}` +
      `<br><b>Q1</b>: ${selectedData.q1}` +
      `<br><b>Q3</b>: ${selectedData.q3}` +
      `<br><b>中位数</b>: ${selectedData.median}` +
      `<br><b>Value</b>: ${d.y}`
          )
        }),
        hovertemplate: '%{text}<extra></extra>' // 直接使用 text 作为 hover 显示内容
      }

      // 计算最大Y值，用于设置Y轴范围
      const maxYValue = Math.max(
        ...boxData1.map(d => d.max),
        ...boxData2.map(d => d.max),
        ...scatterPoints1.map(d => d.y),
        ...scatterPoints2.map(d => d.y)
      )

      // 布局设置
      const layout = {
        plot_bgcolor: 'black',
        paper_bgcolor: 'black',
        font: {
          color: 'white'
        },
        xaxis: {
          title: 'Point',
          tickvals: xValues,
          ticktext: xValues.map((x) => x.toString()),
          range: [Math.min(...xValues) - 1, Math.max(...xValues) + 1],
          color: 'white',
          tickfont: { color: 'white' }
        },
        yaxis: {
          showline: false,
          title: this.selectedDataType,
          range: [0 - maxYValue * 0.1, maxYValue * 1.1], // 调整Y轴范围，增加一些边距
          color: 'white',
          tickfont: { color: 'white' }
        },
        shapes: [
          {
            type: 'line',
            x0: Math.min(...xValues) - 1,
            x1: Math.max(...xValues) + 1,
            y0: 0,
            y1: 0,
            line: {
              color: 'gray',
              width: 1,
              dash: 'dot'
            }
          }
        ],
        hovermode: 'closest',
        dragmode: 'pan',
        autosize: true,
        clickmode: 'event'
      }

      return {
        boxPlotData: [boxPlotData1, boxPlotData2, medianHover1, medianHover2],
        scatterData: [scatterData1, scatterData2],
        layout
      }
    }
  },
  watch: {
    pagination: {
      handler (newName, oldName) {
        if (this.IsSubmitPage) {
          return
        }
        const start = (this.pagination.page - 1) * this.pagination.current.rowsPerPage
        const end = start + this.pagination.current.rowsPerPage
        console.info(this.newData.slice(start, end))
        this.responseData = this.newData.slice(start, end)
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/lcd/hdr/lcdCalibrationAnalyzer/ShowHDRLcdCalibrationColorBoxChart')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          const cache = sessionStorage.getItem('cacheFilterInfo')
          if (cache) {
            // ✅ 優先用 sessionStorage 中的副本
            this.propData = JSON.parse(cache)
          } else {
            // ✅ 第一次從 localStorage 拿到後，存入 sessionStorage
            const raw = localStorage.getItem('hdrlcdFilterInfo')
            if (raw) {
              this.propData = JSON.parse(raw)
              sessionStorage.setItem('cacheFilterInfo', raw)
            }
          }
          console.info(this.$route.params.datatype)
          this.nits = this.$route.params.nits
          this.selectedDataType = this.$route.params.datatype
          // this.lcdFilterUpdateTime = localStorage.getItem('lcdFilterUpdateTime')
          this.doSubmit()
          this.$http.post('/api/lcd/analyzeMgmt/calibrationMode', this.propData).then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                this.calibrationModeMenu = res.data
              }
            })
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    outlierRangeCoefficientChanged () {
      this.loadingView = true
      this.$http.post(`/api/lcd/analyzeMgmt/boxPlatColorVolumeDataList/${this.nits}/${this.selectedDataType}/${this.outlierRangeCoefficient}`, this.propData).then(res => res.data)
        .then(res => {
          this.loadingView = false
          if (res.status === 'success') {
            this.showtable = false
            this.responseAreaData = res.data.statistics
            console.info(this.responseAreaData)
            this.doChart('init')
          } else {
            this.responseAreaData = []
            this.doChart('init')
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '查無資料'
          }
        })
        .catch(err => {
          this.responseAreaData = []
          this.doChart('init')
          this.loadingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    doChart (type) {
    //   this.barXaxisValue = []
    //   this.barXaxisItem.forEach((item, index) => {
    //     this.barXaxisValue.push([this.barXaxisItemName[index]])
    //     this.responseAreaData.forEach((r) => {
    //       if (r[item] >= 0) {
    //         this.barXaxisValue[index].push(r[item])
    //       }
    //     })
    //   })
      this.$nextTick(() => {
        // 确保 DOM 完成渲染后，再初始化图表
        const { boxPlotData, scatterData, layout } = this.options_bar
        console.info(this.options_bar)
        const plotElement = document.getElementById('myChart')
        // 使用 Plotly 创建图表
        Plotly.newPlot('myChart', [...boxPlotData, ...scatterData], layout, { scrollZoom: true }).then(() => {
        // 綁定 plotly_click 事件
          plotElement.on('plotly_click', this.onBoxPlotClick)
        })
      })
      if (type === 'init') {
        // this.handler_bar.$emit('init', this.options_bar)
      } else {
        // this.handler_bar.$emit('dispatch', chart => {
        //   const options = {
        //     xs: { target: 'target_x' },
        //     columns: this.barXaxisValue.concat([['target_x', this.target.x]]).concat([['target', this.target.y]])
        //   }
        //   const optionsXline = [
        //     { value: this.spec.x.low, text: 'x(下限)', position: 'start', class: 'scatter-assign-board-line' },
        //     { value: this.spec.x.high, text: 'x(上限)', position: 'end', class: 'scatter-assign-board-line' }
        //   ]
        //   const optionsYline = [
        //     { value: this.spec.y.low, text: 'y(下限)', position: 'start', class: 'scatter-assign-board-line' },
        //     { value: this.spec.y.high, text: 'y(上限)', position: 'end', class: 'scatter-assign-board-line' }
        //   ]
        //   chart.load(options)
        //   chart.xgrids(optionsXline)
        //   chart.ygrids(optionsYline)
        // })
      }
    },
    doSubmit () {
      this.loadingView = true
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/systemParameter/color_volume_box_plat_outlier_range_coefficient`).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.status === 'success') {
            this.outlierRangeCoefficient = res.data
          }
        })
      this.$http.post(`/api/lcd/analyzeMgmt/boxPlatColorVolumeDataList/${this.nits}/${this.selectedDataType}/${this.outlierRangeCoefficient}`, this.propData).then(res => res.data)
        .then(res => {
          this.loadingView = false
          if (res.status === 'success') {
            this.showtable = false
            this.responseAreaData = res.data.statistics
            console.info(this.responseAreaData)
            this.doChart('init')
          } else {
            this.responseAreaData = []
            this.doChart('init')
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '查無資料'
          }
        })
        .catch(err => {
          this.responseAreaData = []
          this.doChart('init')
          this.loadingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    downloadNBreport (pk) {
      this.processingView = true
      this.$http.get(`/api/lcd/analyzeMgmt/hdrHitraceLog/${pk}`, {}, { responseType: 'blob' })
        .then(res => {
          console.info(res)
          this.processingView = false
          if (res.data.type === 'application/json') {
            return new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onload = () => {
                res.data = JSON.parse(reader.result)
                if (res.data.status === 'success') {
                  alert(res.data.data)
                } else {
                  this.snackbar = true
                  this.snackbarColor = 'red'
                  this.snackbarMsg = res.data.errMsg + ' (' + res.data.errCode + ')'
                }
              }
              reader.onerror = () => {
                reject(res.data.errMsg || res.data.data)
              }
              reader.readAsText(res.data)
            })
          } else if (res.data.status !== 'failure' && res.headers['content-disposition']) {
            const blob = new Blob([res.data], { type: 'application/octet-stream' })
            const url = window.URL.createObjectURL(blob)
            const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
            const downloadLink = document.createElement('a')
            downloadLink.href = url
            downloadLink.download = fileName

            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          } else {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '下載失敗，請通知系統管理員'
          }
        })
        .catch(err => {
          this.processingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    downloadHitTraceLog (pk) {
      this.processingView = true
      this.$http.get(`/api/lcd/analyzeMgmt/hdrNbReport/${pk}`, {}, { responseType: 'blob' })
        .then(res => {
          console.info(res)
          this.processingView = false
          if (res.data.type === 'application/json') {
            return new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onload = () => {
                res.data = JSON.parse(reader.result)
                if (res.data.status === 'success') {
                  alert(res.data.data)
                } else {
                  this.snackbar = true
                  this.snackbarColor = 'red'
                  this.snackbarMsg = res.data.errMsg + ' (' + res.data.errCode + ')'
                }
              }
              reader.onerror = () => {
                reject(res.data.errMsg || res.data.data)
              }
              reader.readAsText(res.data)
            })
          } else if (res.data.status !== 'failure' && res.headers['content-disposition']) {
            const blob = new Blob([res.data], { type: 'application/octet-stream' })
            const url = window.URL.createObjectURL(blob)
            const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
            const downloadLink = document.createElement('a')
            downloadLink.href = url
            downloadLink.download = fileName

            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          } else {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '下載失敗，請通知系統管理員'
          }
        })
        .catch(err => {
          this.processingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    onBoxPlotClick (event) {
      if (!event.points.length) return

      const clickedPoint = Math.round(event.points[0].x) // 取得 X 軸的 point
      const datasetName = event.points[0].data.name // 獲取用戶點擊的是哪個數據集
      // 找到對應的 responseAreaData
      const matchedData = this.responseAreaData.find(item => item.point === clickedPoint)
      if (!matchedData) return
      let selectedData = []
      if (datasetName.includes('Native')) {
        selectedData = matchedData.nativeColorVolume
      } else {
        selectedData = matchedData.colorVolume
      }
      // 根據點擊的數據集 (original, calibration, result) 取得對應數據
      if (!selectedData) return

      // 組裝要顯示的數據
      const clickedInfo = {
        point: clickedPoint,
        dataset: datasetName,
        stats: {
          min: selectedData.min,
          q1: selectedData.q1,
          median: selectedData.median,
          q3: selectedData.q3,
          max: selectedData.max
        },
        belowBoundaryList: selectedData.belowBoundaryList,
        exceedBoundaryList: selectedData.exceedBoundaryList
      }
      this.showtable = true
      this.newData = [...clickedInfo.belowBoundaryList, ...clickedInfo.exceedBoundaryList].map(item => ({
        pk: item.pk,
        isn: item.isn,
        i1sn: item.i1Sn,
        value: item.value // 取出對應的數據列
      }))
      console.info(this.newData)
      this.clicktitle = 'Point:' + clickedInfo.point + ',' + clickedInfo.dataset + ',中位數:' + clickedInfo.stats.median + ',上四分位數:' + clickedInfo.stats.q3 + ',下四分位數:' + clickedInfo.stats.q1 + ',最大值:' + clickedInfo.stats.max + ',最小值:' + clickedInfo.stats.min + '（' + this.newData.length + '）'
      this.responseData = [...this.newData]
      this.pagination.current.totalItems = this.newData.length
      this.IsSubmitPage = true
      this.pages = Number(Math.ceil(this.newData.length / this.pagination.current.rowsPerPage))
      this.IsSubmitPage = false
      this.pagination.page = 1
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */
.c3 .scatter-assign-board-line line{
  stroke: hotpink;
  stroke-width: 2;
  stroke-dasharray: 6;
}
.c3 .c3-circles-target circle{
  fill: green;
  opacity: 1 !important;
}
</style>
